import React from 'react';
import TableComponent from 'component/molecules/Table/TableComponent.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import { chat } from 'hooks/endpoints';
import { headerData } from './factory/ConversationHeader';
import styles from './Conversation.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
const ConversationTemp = ({ isRefetch, isTryMe }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;

  // const renderIsDefault = ({ header, item }) => {
  //   return item?.isTryMe ? (
  //     <SvgWithBranding
  //       className={`${styles.icon} ${styles.tryMe}`}
  //       color={page_ButtonColor}
  //     />
  //   ) : null;
  // };
  return (
    <>
      <TableComponent
        rowKey="chatId"
        headerData={headerData}
        api={{
          get: {
            url: chat.getConversations,
            params: { BotId: id, isTryme: isTryMe === 0 ? false : true },
          },
        }}
        // renderAdditionalComponent={renderIsDefault}
        actions={{
          onRowClick: {
            hasRowClick: true,
            func: (item) => {
              navigate(`/chat-console/${id}`, {
                state: { chatId: item.chatId },
              });
            },
          },
        }}
        isRefetch={isRefetch}
      />
    </>
  );
};

export default ConversationTemp;
